(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // FIX : Tinker masque les cartes (opacity 0 / animation de révélation au
  // scroll) et nos cartes custom ne déclenchent pas son observer.
  // On force l'affichage de tout élément masqué dans la grille, quel que
  // soit le mécanisme (classe, attribut, style inline, animation CSS).
  // FIX page blanche (ceinture + bretelles) : si une View Transition
  // cross-document démarre malgré le CSS, on la skippe immédiatement.
  window.addEventListener('pagereveal', (event) => {
    event.viewTransition?.skipTransition();
  });
  window.addEventListener('pageswap', (event) => {
    event.viewTransition?.skipTransition();
  });

  const forceRevealCards = () => {
    document.querySelectorAll('.product-grid__item').forEach((item) => {
      [item, ...item.querySelectorAll('*')].forEach((el) => {
        if (el.classList.contains('variant-card__img--hover')) return; // doit rester cachée hors survol
        const cs = getComputedStyle(el);
        if (cs.opacity === '0' || cs.visibility === 'hidden' || cs.animationName !== 'none') {
          el.style.setProperty('opacity', '1', 'important');
          el.style.setProperty('visibility', 'visible', 'important');
          el.style.setProperty('transform', 'none', 'important');
          el.style.setProperty('animation', 'none', 'important');
          el.style.setProperty('transition', 'none', 'important');
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', forceRevealCards);
  window.addEventListener('load', forceRevealCards);
  // Filets de sécurité si le JS du thème repasse derrière
  setTimeout(forceRevealCards, 300);
  setTimeout(forceRevealCards, 1000);

  } catch(e) { console.error(e); }
})();
})();
